// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"6821":"css/admin-app.6930","7190":"css/app.6930"}[chunkId] + ".css";
};